// Module
var code = "\n    <div class=\"row-preview\">\n        {{tmpl \"#edit-record-field-label\"}}\n        <span class=\"validation-container\">\n            <textarea rows=\"4\" class=\"text_area textfield text-input\" maxlength=\"1000000\" name=\"${Item.FieldID}\"></textarea>\n        </span>\n    </div>\n";
// Exports
var htmlContent = code;
jQuery.templatesHtml['#edit-record-textarea-field'] = htmlContent;
module.exports = "edit-record-textarea-field";